// Local Storage properties
export const LS_USER_NAME = 'USER_NAME';
export const LS_AUTH_TOKEN = 'AUTH_TOKEN';
export const LS_LOGIN_REDIRECT = 'LOGIN_REDIRECT';
export const ORDER_OPERATIONS = ['order', 'return'];
export const ORDER_ACTIONS = ['request', 'cancel'];
export const ORDER_METHODS = ['email', 'webhook', 'api', 'sftp'];
